import React from "react";
import styled from "@emotion/styled";
import { Container } from "@mui/material";
import { Helmet } from "react-helmet";

import DynamicComponentLoader from "../components/DynamicComponent";

export default function Team({ handleBookATourClick, theme, ...props }) {
  const { Content } = props?.data;

  return (
    <Wrapper>
      <Helmet>
        <title itemProp="name" lang="en">
          The Kahanoff Centre – Location
        </title>
      </Helmet>
      <Container disableGutters align="center" maxWidth={"false"}>
        {Content?.map((block, index) => {
          return <DynamicComponentLoader key={block.Copy} theme={theme} {...block} />;
        })}
      </Container>
    </Wrapper>
  );
}
const Wrapper = styled("div")`
  & h3 {
    column-span: all;
  }
  & .button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;
    box-sizing: border-box;
    background-color: transparent;
    outline: 0;
    border: 0;
    margin: 2rem 0;
    ${props => props.theme.breakpoints.up("sm")} {
      margin: 2rem 0 0;
    }
    border-radius: 0;
    padding: 0;
    cursor: pointer;
    user-select: none;
    vertical-align: middle;
    text-decoration: none;

    font-weight: 500;
    font-size: 0.875rem;
    line-height: 1.75;
    letter-spacing: 0.02857em;
    text-transform: uppercase;
    min-width: 64px;
    padding: 6px 16px;
    border-radius: 4px;
    transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    color: ${props => props.theme.palette.primary.dark};
    background-color: ${props => props.theme.palette.common.white};
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14),
      0px 1px 5px 0px rgba(0, 0, 0, 0.12);
    padding: 0.5rem 2.5rem;

    width: max-content;
    height: 65px;
    text-transform: uppercase;
    border-radius: 200px;
    border: none;
    &:hover {
      text-decoration: none;
      color: ${props => props.theme.palette.common.white};
      background-color: ${props => props.theme.palette.primary.main};
      box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14),
        0px 1px 10px 0px rgba(0, 0, 0, 0.12);
    }
    &:active {
      // color: #fff;
      // background-color: ${props => props.theme.palette.primary.main};
    }
    &.selected {
      // color: #fff;
      // background-color: ${props => props.theme.palette.primary.main};
    }
  }
  & a {
    color: #fff;
    text-decoration: none;
    font-weight: 600;
    &:hover {
      text-decoration: none;
      color: ${props => props.theme.palette.common.white};
      background-color: ${props => props.theme.palette.primary.main};
      box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14),
        0px 1px 10px 0px rgba(0, 0, 0, 0.12);
    }
    &:active {
      color: ${props => props.theme.palette.primary.main};
      // background-color: ${props => props.theme.palette.primary.main};
    }
    &.selected {
      // color: #fff;
      // background-color: ${props => props.theme.palette.primary.main};
    }
  }
  ul {
    display: block;
    width: auto;
    max-width: 575px;
    text-align: left;
    list-style: ${({ options }) => {
      return options?.bullet !== undefined ? "none" : "disc";
    }};
    list-style-position: outside;
    // padding-left: 1rem;
    ${props => props.theme.breakpoints.only("xs")} {
      /* list-style: disc; */
      padding-left: 1rem;
    }
    font-size: 1em;
    ${props => props.theme.breakpoints.up("sm")} {
      /* list-style: disc; */
      // padding-left: 1em;
    }
    &:last-child {
      margin-bottom: 0;
      ${props => props.theme.breakpoints.up("sm")} {
        /* list-style: disc; */
        /* margin-bottom: 2em; */
      }
    }
    li::marker {
      color: ${props => props.theme.palette.primary.main};
    }
    li {
      color: #bdbdbc;
      margin: 0 1rem 0 0 !important;
      display: list-item;
      margin-bottom: 0.25rem;
      break-inside: avoid-column;
      line-height: 35px;
      strong {
        color: ${props => props.theme.palette.text.strong};
      }

      /* TODO Handle no bullet object better */
      &:before {
        /* content: url(${({ options }) => options?.bullet?.file}); */
        display: inline-block;
        position: absolute;
        /* margin-left: ${({ options }) => options?.bullet?.spacing}; */
        margin-top: 3.2px;
      }
      & > a {
        color: ${props => props.theme.palette.primary.main};
        text-decoration: none;
        &:hover {
          color: ${props => props.theme.palette.primary.dark};
        }
        &:visited {
          color: ${props => props.theme.palette.primary.dark};
        }
        &:active {
          color: ${props => props.theme.palette.primary.dark};
        }
      }
    }
  }
`;
